const formStyle = {
        control: (base: any, state: any) => ({
            ...base,
            border: "1px solid #fff !important",
            borderRadius: "0px",
            backgroundColor: state.isDisabled ? "#748d97" : "var(--primary-color)",
            boxShadow: "none",
            minHeight: "45px",
        }),
        placeholder: (base: any, state: any) => ({
            ...base,
            color: state.isFocused ? "var(--primary-color)" : "#fff",
            backgroundColor: "transparent",
            fontSize: "14px",
        }),
        menu: (base: any) => ({
            ...base,
            overflowY: "auto",
            scrollbarWidth: "none",
            color: "#fff"
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: "160px",
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 2,
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? "#eee" : "",
            color: "#000",
            fontWeight: state.isSelected ? "bold" : "",
        }),
        singleValue: (base: any, state: any) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "var(--primary-color)" : state.isSelected ? "#000" : "#fff",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'red',
        }),
    };

export default formStyle;